export const filterByTags = (prods, state) => {
  let active_tags = state['Shape'] !== null && state['Shape'] !== '' ? { 'Shape': state['Shape'] } : {}

  const tags = state['Tags']
  let filtered_prods = prods

  for (const key in state['Tags']) {
    if (tags[key] !== '' && tags[key] !== null) {
      active_tags[key] = tags[key]
    }
  }

  for (const key in active_tags) {
    let tag = key + '_' + active_tags[key]
    filtered_prods = filtered_prods.filter((prod) => prod.tags.includes(tag))
  }

  if (state['Price'] !== null) {
    filtered_prods = filtered_prods.filter(pred => pred.price >= state['Price'][0] && pred.price <= state['Price'][1])
  }

  return filtered_prods
}